import { useQuery } from '@tanstack/react-query'
import { keys } from '@/api/hooks/shared/keys'
import { loadMultipleDevices } from './multipleDeviceData'
import type { MultipleDeviceQuery } from './multipleDeviceTypes'

/**
 * Multiple Device Ids — Winner shared-device list.
 *
 * Live Keycloak → Player-API `getPlayersWithSameDeviceIds` (`users.device_ids`).
 * Demo → local fixtures. Unreachable Player-API → unavailable (never invents rows).
 */
export function useMultipleDevices(query: MultipleDeviceQuery) {
  return useQuery({
    queryKey: keys.multipleDevices(query),
    queryFn: () => loadMultipleDevices(query),
    placeholderData: (previous) => previous,
    retry: false,
  })
}
